export function cloneStockCategories(categories) {
	if (!Array.isArray(categories)) {
		return []
	}
	return categories.map(function(category) {
		return {
			key: category.key,
			name: category.name,
			items: category.items.map(function(item) {
				return Object.assign({}, item)
			}),
		}
	})
}

const CATEGORY_KEY_LABELS = {
	cid1: '服装',
	cid2: '鞋',
	cid3: '配件',
}

function getCategoryLabel(categoryKey) {
	const key = String(categoryKey)
	const matched = key.match(/^cid([123])(?:=|$)/)
	if (matched) {
		return CATEGORY_KEY_LABELS['cid' + matched[1]] || key
	}
	return CATEGORY_KEY_LABELS[key] || key
}

function normalizeCategoryKey(value) {
	if (value == null || value === '') {
		return ''
	}
	return String(value)
}

function parseCidFromCategoryKey(categoryKey) {
	const matched = String(categoryKey).match(/^cid(\d+)/)
	return matched ? Number(matched[1]) : undefined
}

function normalizeStockValue(value) {
	if (value == null || value === '') {
		return 0
	}
	return Math.round(Number(value))
}

function normalizeDiscountValue(value) {
	if (value == null || value === '') {
		return 0
	}
	return Math.round(Number(value) * 100) / 100
}

function mapStockItemFromApi(item, categoryKey, sizeKey) {
	return {
		id: item.id != null && item.id !== '' ? item.id : null,
		category_key: categoryKey,
		cid: item.cid != null ? Number(item.cid) : parseCidFromCategoryKey(categoryKey),
		size: sizeKey,
		stock: normalizeStockValue(item.stock != null ? item.stock : item.safety_stock),
		discount: normalizeDiscountValue(item.discount != null ? item.discount : item.safety_discount),
	}
}

export function mapStockCategoriesToApi(stockCategories) {
	const result = []
	let category
	let item
	let i
	let j

	if (!Array.isArray(stockCategories)) {
		return result
	}

	for (i = 0; i < stockCategories.length; i++) {
		category = stockCategories[i]
		if (!category || !Array.isArray(category.items)) {
			continue
		}
		for (j = 0; j < category.items.length; j++) {
			item = category.items[j]
			if (!item) {
				continue
			}
			const categoryKey = item.category_key || category.key
			result.push({
				id: item.id != null && item.id !== '' ? item.id : null,
				category_key: categoryKey,
				cid: item.cid != null ? Number(item.cid) : parseCidFromCategoryKey(categoryKey),
				size: String(item.size),
				stock: normalizeStockValue(item.stock),
				discount: normalizeDiscountValue(item.discount),
			})
		}
	}

	return result
}

export function buildStockCategoriesFromApi(apiStocks) {
	if (!Array.isArray(apiStocks) || apiStocks.length === 0) {
		return []
	}

	const categoryMap = {}
	const orderedKeys = []
	let i
	let item
	let categoryKey
	let sizeKey
	let group

	for (i = 0; i < apiStocks.length; i++) {
		item = apiStocks[i]
		if (!item) {
			continue
		}
		categoryKey = normalizeCategoryKey(item.category_key || item.category || item.cat_key)
		sizeKey = item.size != null ? String(item.size) : ''
		if (!categoryKey || !sizeKey) {
			continue
		}
		if (!categoryMap[categoryKey]) {
			categoryMap[categoryKey] = {
				key: categoryKey,
				name: getCategoryLabel(categoryKey),
				itemsMap: {},
				itemOrder: [],
			}
			orderedKeys.push(categoryKey)
		}
		group = categoryMap[categoryKey]
		if (group.itemsMap[sizeKey] == null) {
			group.itemOrder.push(sizeKey)
		}
		group.itemsMap[sizeKey] = mapStockItemFromApi(item, categoryKey, sizeKey)
	}

	return orderedKeys.map(function(mapKey) {
		group = categoryMap[mapKey]
		return {
			key: group.key,
			name: group.name,
			items: group.itemOrder.map(function(size) {
				return Object.assign({}, group.itemsMap[size])
			}),
		}
	})
}



// WEBPACK FOOTER //
// ./src/components/StoreConfig/detailed/safetyStockCategories.js